// extracted by mini-css-extract-plugin
module.exports = {"iframe":"ChatIframe_iframe__zkNwS","fullScreen":"ChatIframe_fullScreen__Crel_","minimized":"ChatIframe_minimized__qX73R"};